/**=========================================================
 * Module: groups.js
 * Groups Controller
 =========================================================*/

App.controller('GroupsController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter) {
    "use strict";
     
    $scope.type = 'group';
    $scope.filter = $state.params.filter;
    
    $scope.isClients = $scope.filter.toUpperCase().indexOf('=CLIENT')>=0;

    $scope.data = [];
    
    $scope.page = {
        title: $scope.isClients ? 'sidebar.nav.CLIENTS' : 'sidebar.nav.SUPPLIERS',
        subTitle: 'labels.GROUPS'
    };
    
    $scope.openWordsManage = function(group){
    	$rootScope.changePage({action:'credits',type:'group',filter:group.id});
    };
    $scope.openMemoriesManage = function(group){
    	$rootScope.changePage({action:'memories',type:'group',filter:group.id});
    };
    $scope.openEditGroup = function(group){
    	$rootScope.changePage({action:'edit',type:'group',filter:group.id});
    };
    $scope.openEditReference = function(group){
    	$rootScope.changePage({action:'manage',type:'references',filter:group.id});
    };
    $scope.openProjects = function(group){
        $rootScope.changePage({ action: 'list', type: 'projects', filter: 'group=' + group.id })
    };
    $scope.openOrders = function(group){
        $rootScope.changePage({ action: 'orders', type: 'group', filter: group.id })
    }

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        

    	if($rootScope.user.id){
            $scope.initialized = true;

            let isInArray = function(columnsType, array){
                return array.indexOf(columnsType)>=0
            }

            let initTable = function(columnsType){
                $scope.table = {
                    type: 'group',
                    title: '',
                    cls: 'no-panel-table',
                    baseFilter: $scope.filter,
                    filter: true,
                    loading: true,
                    includedFields: ['id','opts','supergroupName'],
                    loadCallback: function(scope){
                        let response = scope.data
                        response = response.sort(function(a,b){
                            return (a.supergroupName + a.name).toLowerCase() > (b.supergroupName + b.name).toLowerCase() ? 1 : -1;
                        })
                        var currentSuperGroup = null
                        $scope.data = []
                        for(var i=0; i<response.length; i++){
                            if(response[i].supergroupName!=currentSuperGroup){
                                $scope.data.push({
                                    __separator: true,
                                    __label: (response[i].supergroupName ? response[i].supergroupName : '['+$filter('translate')('labels.NONESUPERGROUP') + ']')
                                })
                            }
                            currentSuperGroup = response[i].supergroupName
                            
                            for (let oi in response[i].opts) {
                                response[i][oi] = response[i].opts[oi]
                            }
                            $scope.data.push(response[i])
                        }
                        if($scope.isClients){
                            D.query('group', $scope.filter + '&_withCounters=true', { cache: false }).then(function(response){
                                $scope.table.fields.find(function(f){ return f.name=='words' }).loadingData = false
                                for(var i=0; i<response.length; i++){
                                    ($scope.data.find(function(model){ return model.code==response[i].code}) || {}).words = response[i].words
                                }
                            }).catch(console.error)
                        }
                    },
                    fields: [
                        {
                            available: $scope.isClients,
                            type: 'img',
                            name: 'logo',
                            noLabel: true
                        },{
                            available: true,
                            hasLink: true,
                            name: 'name',
                            filterType: 'text'
                        },{
                            available: true,
                            name: 'code',
                            filterType: 'text',
                            style: {
                                'max-width': '80px'
                            }
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'supergroupLineName'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'words',
                            type: 'number',
                            loadingData: true
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general','tm']),
                            name: 'searchmemories',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general','tm']),
                            name: 'canaskfortm',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general', 'review']),
                            name: 'hasReviewInProject',
                            label: 'hasReview',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['review']),
                            name: 'canAnticipateReview',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['review']),
                            name: 'sourceFilesInReview',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['review']),
                            name: 'hasReviewDeadline',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['review']),
                            name: 'reviewMode',
                            type: 'text'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general', 'glossary']),
                            name: 'hasGlossary',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['discount']),
                            name: 'discountContext',
                            type: 'number',
                            def: 0
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['discount']),
                            name: 'discountFull',
                            type: 'number',
                            def: 0
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['discount']),
                            name: 'discountFuzzy',
                            type: 'number',
                            def: 0
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['discount']),
                            name: 'discountNo',
                            type: 'number',
                            def: 0
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['notification']),
                            name: 'selfnotifications',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['notification']),
                            name: 'receiveOfferPdf',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['notification']),
                            name: 'receiveDelivered',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['project']),
                            name: 'skipSourceReport',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['project']),
                            name: 'hasImportProject',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['project']),
                            name: 'autodelivery',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['project']),
                            name: 'skipConfirm',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['project']),
                            name: 'skipConfirmLimit',
                            type: 'currency'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['project']),
                            name: 'canUploadAsLink',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['project']),
                            name: 'hasQAi',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['project']),
                            name: 'defaultSourceFilesVisible',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['fields']),
                            name: 'offerDlFieldWTime',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['fields']),
                            name: 'noDtpInOffers',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['packet']),
                            name: 'viewPacketTransactions',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['packet']),
                            name: 'doNotSubtractTranslatedWords',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['packet']),
                            name: 'previewWords',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['sectors']),
                            name: 'hasSectorInProject',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['sectors']),
                            name: 'maxOneUserPerSector',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['sectors']),
                            name: 'acceptingUserFromSector',
                            type: 'boolean'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'locations',
                            type: 'text',
                            label: 'BUCKETLOCATIONS',
                            type: 'enumSet',
                            enumType: 'locations',
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'managewords',
                            noLabel: true,
                            iconTooltip: 'fields.MANAGEWORDS',
                            type: 'click',
                            onclick: $scope.openWordsManage,
                            icon: 'aqi-plus'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'managememories',
                            noLabel: true,
                            iconTooltip: 'fields.MANAGEMEMORIES',
                            type: 'click',
                            onclick: $scope.openMemoriesManage,
                            icon: 'aqi-tm'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'editgroup',
                            noLabel: true,
                            iconTooltip: 'labels.EDITGROUP',
                            type: 'click',
                            onclick: $scope.openEditGroup,
                            icon: 'aqi-action-edit'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'editreference',
                            noLabel: true,
                            iconTooltip: 'labels.EDITREFERENCE',
                            type: 'click',
                            onclick: $scope.openEditReference,
                            icon: 'aqi-reference'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'projects',
                            noLabel: true,
                            iconTooltip: 'fields.PROJECTS',
                            type: 'click',
                            onclick: $scope.openProjects,
                            icon: 'aqi-projects'
                        },{
                            available: $scope.isClients && isInArray(columnsType, ['general']),
                            name: 'orders',
                            noLabel: true,
                            iconTooltip: 'fields.ORDERS',
                            type: 'click',
                            onclick: $scope.openOrders,
                            icon: 'aqi-order'
                        }
                    ],
                    link: {
                        action: $scope.isClients ? 'manage' : 'view',
                        type: $scope.isClients ? 'client' : 'group',
                        filter: 'id'
                    },
                    links: [{
                        link: {
                            action: 'create',
                            type:'group',
                            filterValue: $scope.isClients ? 'CLIENT' : 'SUPPLIER'
                        },
                        label: $scope.isClients ? 'labels.ADDNEWCLIENT' : 'labels.ADDNEWSUPPLIER',
                        icon: 'aqi-plus'
                    },{
                        link: !$scope.isClients ? null : {
                            action: 'list',
                            type:'supergroups'
                        },
                        label: 'labels.SUPERGROUPLIST',
                        icon: 'aqi-supergroup'
                    }],
                    commandButtons: [{
                        available: $scope.isClients,
                        isDropdown: true,
                        label: 'labels.CHOOSESETTINGS',
                        onclick: function(opt){
                            initTable(opt.value)
                        },
                        options: [
                            { label: 'labels.GENERALSETTINGS', value: 'general' },
                            { label: 'labels.DISCOUNTSETTINGS', value: 'discount' },
                            { label: 'labels.TMSETTINGS', value: 'tm' },
                            { label: 'labels.NOTIFICATIONSETTINGS', value: 'notification' },
                            { label: 'labels.PROJECTSETTINGS', value: 'project' },
                            { label: 'labels.FIELDSETTINGS', value: 'fields' },
                            { label: 'labels.PACKETSETTINGS', value: 'packet' },
                            { label: 'labels.SECTORSSETTINGS', value: 'sectors' },
                            { label: 'labels.REVIEWSETTINGS', value: 'review' },
                            { label: 'labels.GLOSSARIES', value: 'glossary' }
                        ]
                    }]
                }
            }
            initTable('general')
        
        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();
      
  }
  ]);